import service from './axios';
export const getHotelOrders = (params = {}) => service.get('/manage/orders/hotel', { params });
export const getParkOrders = (params = {}) => service.get('/manage/orders/park', { params });
export const getDaycareOrders = (params = {}) => service.get('/manage/orders/daycare', { params });
export const getMallOrders = (params = {}) => service.get('/manage/orders/mall', { params });
export const getOrderDetail = (id) => service.get(`/manage/orders/${id}`);
export const cancelOrder = (id) => service.post(`/manage/orders/${id}/cancel`);
export const getRefundList = (params) => service.get('/manage/refunds', { params });
export const processRefund = (id) => service.post(`/manage/refunds/${id}/refund`);
export const getAfterSaleList = (params) => service.get('/manage/after-sales', { params });
export const approveAfterSale = (id, data) => service.put(`/manage/after-sales/${id}/approve`, data);
export const rejectAfterSale = (id, data) => service.put(`/manage/after-sales/${id}/reject`, data);
export const getReviewList = (params) => service.get('/manage/reviews', { params });
export const toggleReviewHide = (id) => service.put(`/manage/reviews/${id}/toggle-hide`);
export const getOrderTimeSettings = () => service.get('/manage/order-time-settings');
export const updateOrderTimeSettings = (data) => service.put('/manage/order-time-settings', data);
export const getCartConfig = () => service.get('/manage/cart-config');
export const updateCartConfig = (data) => service.put('/manage/cart-config', data);
